import initializeAxios from './axiosSetup';
import { axiosKioskRequestConfiguration } from './config';
import createApiMethods from '@/api/createApiMethods';

export const axiosInstance = initializeAxios(axiosKioskRequestConfiguration);

const api = createApiMethods(axiosInstance);

export default api;
